export var typography = {
    headingsH1: {
        fontWeightKey: "semibold",
        fontSizePx: 48,
        letterSpacingPx: -0.5,
        lineHeightPx: 56,
    },
    headingsH2: {
        fontWeightKey: "semibold",
        fontSizePx: 40,
        letterSpacingPx: -0.25,
        lineHeightPx: 48,
    },
    headingsH3: {
        fontWeightKey: "semibold",
        fontSizePx: 30,
        letterSpacingPx: -0.25,
        lineHeightPx: 38,
    },
    headingsH4: {
        fontWeightKey: "semibold",
        fontSizePx: 24,
        letterSpacingPx: 0,
        lineHeightPx: 32,
    },
    headingsH5: {
        fontWeightKey: "semibold",
        fontSizePx: 20,
        letterSpacingPx: 0.25,
        lineHeightPx: 24,
    },
    subtitlesLarge: {
        fontWeightKey: "medium",
        fontSizePx: 16,
        letterSpacingPx: 0.15,
        lineHeightPx: 24,
    },
    subtitlesDefault: {
        fontWeightKey: "medium",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 22.4,
    },
    bodyLarge: {
        fontWeightKey: "regular",
        fontSizePx: 16,
        letterSpacingPx: 0.15,
        lineHeightPx: 24,
    },
    bodyDefault: {
        fontWeightKey: "regular",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 22.4,
    },
    formsButton: {
        fontWeightKey: "medium",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 24,
    },
    captionDefault: {
        fontWeightKey: "regular",
        fontSizePx: 13,
        letterSpacingPx: 0.15,
        lineHeightPx: 20.8,
    },
    formsTextField: {
        fontWeightKey: "regular",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 24,
    },
    formsLabel: {
        fontWeightKey: "regular",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 18,
    },
    captionStrong: {
        fontWeightKey: "medium",
        fontSizePx: 13,
        letterSpacingPx: 0.15,
        lineHeightPx: 20.8,
    },
    codeDefault: {
        fontWeightKey: "regular",
        fontSizePx: 14,
        letterSpacingPx: 0.15,
        lineHeightPx: 20,
    },
    codeSmall: {
        fontWeightKey: "regular",
        fontSizePx: 12,
        letterSpacingPx: 0.25,
        lineHeightPx: 18,
    },
    formsOverline: {
        fontWeightKey: "semibold",
        fontSizePx: 11,
        letterSpacingPx: 0.8,
        lineHeightPx: 18,
        textCase: "UPPER",
    },
    headingsH6: {
        fontWeightKey: "semibold",
        fontSizePx: 18,
        letterSpacingPx: 0.15,
        lineHeightPx: 24,
    },
};
export var colors = {
    red: {
        lighter: "#ffaba4",
        light: "#ff685b",
        base: "#d03c38",
        dark: "#aa2d31",
        darker: "#841e2a",
        lightest: "#ffeeed",
        darkest: "#5f0f24",
    },
    yellow: {
        lighter: "#f6e8ad",
        light: "#f1d977",
        base: "#ebca40",
        dark: "#b8952e",
        darker: "#85611b",
        darkest: "#522c09",
        lightest: "#fcf7e4",
    },
    green: {
        lighter: "#88e3cd",
        light: "#31cea8",
        base: "#13a688",
        dark: "#0d8975",
        darker: "#066b61",
        darkest: "#004e4e",
        lightest: "#def7f1",
    },
    blue: {
        lighter: "#99c2f9",
        light: "#549af6",
        base: "#1071f2",
        dark: "#0b61cb",
        darker: "#0550a4",
        darkest: "#00407d",
        lightest: "#ddebfd",
    },
    purple: {
        lighter: "#bcbaff",
        light: "#908bff",
        base: "#635dff",
        dark: "#564ed1",
        darker: "#493fa3",
        darkest: "#3c3075",
        lightest: "#e9e8ff",
    },
    magenta: {
        lighter: "#ffaff0",
        light: "#ff79e7",
        base: "#ff44dd",
        dark: "#c638a7",
        darker: "#8d2b72",
        lightest: "#ffe4fa",
        darkest: "#541f3c",
    },
    neutral: {
        white: "#ffffff",
        lightest: "#eff0f2",
        lighter: "#e3e4e6",
        light: "#c9cace",
        base: "#96989d",
        dark: "#65676e",
        darker: "#41444b",
        darkest: "#1e212a",
        black: "#000000",
    },
    text: {
        dark: "#1e212a",
        white: "#ffffff",
        link: "#635dff",
        light: "#65676e",
    },
    other: {
        "auth0 orange": "#eb5424",
    },
    component: {
        focus: "#1071f2",
    },
};
